// extracted by mini-css-extract-plugin
module.exports = {"field":"TaxJarInfo_field__1RNlm","wrapper":"TaxJarInfo_wrapper__2D60w","title":"TaxJarInfo_title__2lKQz"};